import { Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

function MobileScale({ value, onChange, ratings }) {
  return (
    <FormControl size="small" sx={{ minWidth: 80 }}>
      <Select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        renderValue={(v) => v || '--'}
        sx={{
          borderColor: 'svceGreen.main',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'svceGreen.main' },
        }}
      >
        {ratings.map((num) => (
          <MenuItem key={num} value={num}>{num}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

function DesktopScale({ value, onChange, ratings, size }) {
  return(
    <>
      <Typography
        sx={{ color: 'primary.main', fontWeight: 600, fontSize: '0.75rem', mr: 1 }}
      >
        NOT SATISFIED
      </Typography>
      {ratings.map((num) => (
        <Button
          key={num}
          data-rating={num}
          onClick={() => onChange(num)}
          variant={value === num ? 'contained' : 'outlined'}
          color="svceGreen"
          sx={{
            minWidth: size,
            width: size,
            height: size,
            p: 0,
            borderColor: value === num ? 'primary.main' : 'grey.400',
            color: value === num ? 'common.white' : 'text.primary',
            fontWeight: 600,
            fontSize: '0.875rem',
            borderRadius: '4px',
          }}
        >
          {num}
        </Button>
      ))}
      <Typography
        sx={{ color: 'primary.main', fontWeight: 600, fontSize: '0.75rem', ml: 1 }}
      >
        SATISFIED
      </Typography>
    </>
  );
}

const RATINGS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; 
const DESKTOP_SIZE = 36;

export default function SatisfactionScale({ value, onChange }) {
  const theme = useTheme();
  const desktopWidth = useMediaQuery(theme.breakpoints.up('sm'));
  const ratings = RATINGS;
  const size = DESKTOP_SIZE;

  return (
    <Box display="flex" justifyContent="center" alignItems="center" gap={0.5} flexWrap="wrap">
      {desktopWidth ? (
        <DesktopScale value={value} onChange={onChange} ratings={ratings} size={size} />
      ) : (
        <MobileScale ratings={ratings} value={value} onChange={onChange} />
      )}
    </Box>
  );
}
